/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(5), __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, _) {
    'use strict';

    angular.module('ecButton', ['mstarCore']).directive('ecButton', ['mstarTemplate', 'mstarDebounce', '$interpolate', button]);

    function button(mstarTemplate, mstarDebounce, $interpolate) {
        return {
            restrict: 'E',
            require: 'mstarComponentId',
            scope: {
                label: '@?',
                model: '=?buttonData'
            },
            link: linkFn
        };

        function linkFn(scope, elem, attr, mstarComponent) {

            // binds settings, labels, formatter and templates to scope properties
            mstarComponent.bindConfig(scope);

            // binds parameters (two-way between the asterix instance's parameters and scope.parameters)
            mstarComponent.bindParameters(scope);

            // initiates our scope.model according to settings and two-way binds it to the asterix instance's model
            if (attr.buttonData) {
                scope.instance.setModel(scope.model);
            } else {
                mstarComponent.bindModelData(scope);
            }

            var parameters = scope.parameters;
            scope.iconPositionClass = parameters.iconPosition === 'left' ? 'ec-components-u-leftAlign' : 'ec-components-u-rightAlign';

            scope.buttonClick = function (event) {
                if (parameters.onClick !== null && typeof parameters.onClick === 'function') {
                    parameters.onClick(event);
                }
                mstarComponent.trigger('click', [event]);
            };
            var currentTemplate = '_templates.' + (scope.settings.get('_templates')[parameters.buttonType] ? parameters.buttonType : 'main');

            // compiles the main template
            mstarComponent.compileTemplate(scope, currentTemplate);

            // Button label
            if (scope.label) {
                scope.$watch(function () {
                    return $interpolate(scope.labels.get(scope.label))(scope);
                }, function (value) {
                    scope.buttonLabel = value;
                });
            } else {
                scope.$watch(function () {
                    return $interpolate(scope.labels.get('caption'))(scope);
                }, function (value) {
                    scope.buttonLabel = value;
                });
            }

            if (parameters.buttonType === 'link') {
                generateHref();
            }

            scope.$watch('parameters.href', mstarDebounce(function () {
                generateHref();
            }, 20), true);

            scope.$watch('parameters.hrefParams', mstarDebounce(function () {
                generateHref();
            }, 20), true);

            function generateHref() {
                var href = scope.parameters.href;
                if (href && href !== '') {
                    var queryParams = morningstar.asterix.util.merge({}, scope.settings.get('hrefParams'), scope.parameters.hrefParams);
                    _.each(queryParams, function (value, key, obj) {
                        obj[key] = encodeURIComponent(value);
                    });
                    scope.href = morningstar.asterix.util.url.parameterize(href, queryParams);
                }
            }
        }
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = {
	"ecButton": {
		"labels": {
			"caption": {
				"en": null,
				"en-GB": null,
				"sv-SE": null
			}
		},
		"settings": {
			"_model": {
				"disabled": false
			},
			"_parameters": {
				"badgeContent": {},
				"buttonCSS": {},
				"buttonType": {},
				"captionLabelKey": {},
				"disabled": {},
				"href": {},
				"hrefParams": {},
				"iconCSS": {},
				"iconPosition": {},
				"onClick": {},
				"visible": {}
			},
			"_templates": {
				"badge": "<button title=\"{{ parameters.captionLabelKey ? labels.get(parameters.captionLabelKey) : buttonLabel }}\"\r\n    data-ng-if=\"parameters.visible\" data-ng-attr-type=\"{{parameters.buttonType}}\" data-ng-click=\"buttonClick($event)\"\r\n    class=\"{{ ::namespaceClass('__btn') + ' '+ namespaceClass('__badge-btn') }} {{parameters.buttonCSS}}\"\r\n    data-ng-disabled=\"parameters.disabled\">\r\n    <span data-ng-if=\"parameters.iconCSS\" class=\"{{ ::namespaceClass('__icon') }}\" data-ng-class=\"parameters.iconCSS\"></span>\r\n    <span class=\"{{ ::namespaceClass('__caption') }}\">{{ parameters.captionLabelKey ? labels.get(parameters.captionLabelKey) : buttonLabel }}</span>\r\n    <span class=\"{{ ::namespaceClass('__badge-content') }}\">{{parameters.badgeContent}}</span>\r\n</button>",
				"icon": "<button title=\"{{ parameters.captionLabelKey ? labels.get(parameters.captionLabelKey) : buttonLabel }}\"\r\n    data-ng-if=\"parameters.visible\" data-ng-attr-type=\"{{parameters.buttonType}}\" data-ng-click=\"buttonClick($event)\"\r\n    class=\"{{ ::namespaceClass('__btn') + ' ' + namespaceClass('--icon-only') }} {{parameters.buttonCSS}}\"\r\n    data-ng-disabled=\"parameters.disabled\" role=\"button\">\r\n    <svg class=\"mui-icon mui-button__icon\">\r\n        <use data-ng-attr-href=\"{{ ::settings.get('iconSprite') }}.svg#{{ ::settings.get('iconName') }}\"/>\r\n    </svg>\r\n</button>",
				"link": "<a title=\"{{ parameters.captionLabelKey ? labels.get(parameters.captionLabelKey) : buttonLabel }}\"\r\n    data-ng-if=\"parameters.visible\" href=\"{{href}}\" target=\"{{ ::settings.get('target') }}\"\r\n    data-ng-click=\"buttonClick($event)\" class=\"{{ ::namespaceClass('__link') }} {{parameters.buttonCSS}}\">\r\n    <span data-ng-if=\"parameters.iconCSS\" class=\"{{iconPositionClass}}\" data-ng-class=\"parameters.iconCSS\"></span>\r\n    {{ parameters.captionLabelKey ? labels.get(parameters.captionLabelKey) : buttonLabel }}\r\n</a>\r\n",
				"main": "<button title=\"{{ parameters.captionLabelKey ? labels.get(parameters.captionLabelKey) : buttonLabel }}\"\r\n    data-ng-if=\"parameters.visible\" data-ng-attr-type=\"{{parameters.buttonType}}\"\r\n    data-ng-click=\"buttonClick($event)\" class=\"{{ ::namespaceClass('__btn') }} {{parameters.buttonCSS}}\" data-ng-disabled=\"parameters.disabled || model.disabled\">\r\n    <span data-ng-if=\"parameters.iconCSS\" class=\"{{namespaceClass('__icon')}}\" data-ng-class=\"parameters.iconCSS\"></span>\r\n    <span class=\"{{ ::namespaceClass('__caption') }}\">{{ parameters.captionLabelKey ? labels.get(parameters.captionLabelKey) : buttonLabel }}</span>\r\n</button>\r\n"
			},
			"badgeContent": null,
			"buttonCSS": "ec-components-button",
			"buttonType": "button",
			"disabled": false,
			"href": null,
			"hrefParams": null,
			"iconCSS": null,
			"iconName": "person-padless",
			"iconPosition": "left",
			"iconSprite": "mds_icons",
			"namespaceClass": "ec-button",
			"onClick": null,
			"target": null,
			"visible": true
		},
		"type": "ecButton"
	}
};

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = morningstar;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
    'use strict';

    morningstar.asterix.ng.register('ecButton', __webpack_require__(1).ecButton);
    __webpack_require__(0);
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = _;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = angular;

/***/ })
/******/ ]);
//# sourceMappingURL=ec-button.js.map


// WEBPACK FOOTER //
// ./components/button/build/ec-button.js